import styled from "styled-components";
import { Modal } from "antd";

export const ModalWrapper = styled(Modal)`
  .ant-modal-header,
  .ant-modal-close-x {
    display: none;
  }

  .ant-modal {
    top: 400px;
  }

  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-body {
    padding-top: 40px;

    > p {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 0;
      font-size: 16px;
      font-weight: 600;
      white-space: pre-line;
    }
  }

  .ant-modal-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 0;
    padding: 10px;

    button {
      border-radius: 8px;
      border: 0;
      cursor: pointer;
      min-width: 120px;
      padding: 6px;
      color: #ffffff;
      text-align: center;
      font-size: 14px;
    }
  }

  .button-cancel {
    border: 1px solid #d9d9d9 !important;
    background: #fff !important;
    color: rgba(0, 0, 0, 0.85) !important;
  }
`;
